<div class="d-flex justify-content-between align-items-baseline">
  <ng-content></ng-content>

  <button *ngIf="enabledCopy" mat-icon-button matTooltip="{{ tooltip | translate }} {{prefix | translate}}"
    (click)="clickedBtn()">
    <mat-icon>content_copy</mat-icon>
  </button>
</div>